import styled, { css } from 'styled-components'

export const Container = styled.div<{ $height: number }>`
  position: relative;
  height: ${({ $height }) => $height}px;
  background: var(--bg-tertiary);
`

export const Bar = styled.div<{ $color?: string }>`
  position: absolute;
  top: 0;
  left: 0;
  transition: width 0.3s ease-in-out;
  height: 100%;
  background: var(--bg-primary-invert);

  ${({ $color }) =>
    $color &&
    css`
      background: ${$color};
    `}
`
